export default __webpack_public_path__ + "static/media/mode-25.2e597e50.svg";